import { render, staticRenderFns } from "./ItemTierBreakdown.vue?vue&type=template&id=a59ea0a4&"
import script from "./ItemTierBreakdown.vue?vue&type=script&lang=js&"
export * from "./ItemTierBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports